export const BASE_URL = process.env.REACT_APP_BASE_API_URL;
export const URL =`${BASE_URL}/api/`;
export const BRAND_IMAGE_URL = `${BASE_URL}/uploads/brand`;
export const CATEGORY_IMAGE_URL = `${BASE_URL}/uploads/category/`;
export const PRODUCT_IMAGE_URL = `${BASE_URL}/uploads/product/`;
